import Cookie from 'js-cookie';
import axios from '@xpeng/union-login';
import { getDeviceId } from './common';
import MessageBox from '../components/message-box';
import * as Sentry from '@sentry/browser';
import { isDebug } from '@/config';

const key: string = 'xp_car_owner_service'; // 用户中心应用KEY
const baseUrl: string = '/api'; // 请求接口前辍

const cancelAppLogin = () => { // 客户端取消登录回调
  window.location.reload();
};
const popupAppLogin = (callback) => { // 弹出APP登录界面后回调方法
  callback();
  MessageBox.confirm('如未成功登录，请重试', { showCancelButton: false, confirmButtonText: '重试'})
    .then(() => window.location.reload());
};
const showError = (err) => { // 显示服务端报错信息
  if (err.response && err.response.data && err.response.data.msg) {
    MessageBox.toast(err.response.data.msg);
  } else {
    MessageBox.toast(err.message);
  }
};

/**
 * 处理GET请求参数
 * @param params
 */
const processGetParams = (params: any) => {
  if (isDebug) params.preUid = Cookie.get('wasxuid_r')
  params.redirectUrl = window.location.href;
  return params;
};

/**
 * 处理POST请求参数
 * @param params
 */
const processPostParams = (params: any) => {
  if (isDebug) params.preUid = Cookie.get('wasxuid_r')
  params.redirectUrl = window.location.href;
  return params;
};
const processPostUrlParams = (params: any) => {
  params.redirectUrl = window.location.href
  return params;
};

/**
 * 处理返回参数
 * @param res
 */
const returnData = (res: any) => {
  const { data } = res;
  return data;
};

/**
 * 获取自定义头部信息
 */
const formatHeader = () => {
  return {
    'XP-Uid': Cookie.get('wasxuid_r') || '',
    'XP-Appid': key,
    'XP-DeviceId': getDeviceId('xp-car-owner-service') || '',
    'XP-Xid': '',
    'XP-Nonce': Date.now(),
  };
};

const axiosInstance = axios({
  key,
  baseUrl,
  cancelAppLogin,
  showError,
  processGetParams,
  processPostParams,
  processPostUrlParams,
  getMiniProgramLoginUrl: function () {
    return `/pages/user/login?appId=${key}&webviewUrl=${encodeURIComponent(window.location.href)}`;
  },
  popupAppLogin,
  returnData,
});

// 添加error的sentry监控
const origin_get = axiosInstance.get
axiosInstance.get = function get(url: string, params?: any, options?: any) {
  Sentry.addBreadcrumb({
    type: 'network-request',
    message: `${url}`,
    data: {
      url,
      params,
      options
    }
  });
  return origin_get.call(axiosInstance, url, params, options).catch(e => {
    Sentry.captureException(e)
    throw e
  })
}
const origin_post = axiosInstance.post
axiosInstance.post = function post(url: string, params?: any, options?: any) {
  Sentry.addBreadcrumb({
    type: 'network-request',
    message: `${url}`,
    data: {
      url,
      params,
      options
    }
  });
  return origin_post.call(axiosInstance, url, params, options).catch(e => {
    Sentry.captureException(e)
    throw e
  })
}

export default {
  get: (url, params = {}, options = {}) => {
    Object.assign(options, { headers: formatHeader() });
    return axiosInstance.get(url, params, options);
  },
  post: (url, params = {}, options = {}) => {
    Object.assign(options, { headers: formatHeader() });
    return axiosInstance.post(url, params, options);
  },
};